import React, { useState } from 'react'
import CMS from '../CMS/CMS'
import { useForm } from 'react-hook-form'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from '@tanstack/react-query'
import Swal from 'sweetalert2'
import { Button, Form } from 'react-bootstrap'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import  { CKEditor,CKEditorContext } from '@ckeditor/ckeditor5-react'
import OrderDateFilter from '../../components/OrderDateFilter'
const PrivacyPolicy = () => {

    const {handleSubmit,formState: { errors }} = useForm({})
    const [currentCmsId, setCurrentCmsId] = useState()
    const [ckeditordata, setckeditordata] = useState(null)
    function handleCKEditor(event, editor) {
        const data = editor.getData()
        setckeditordata(data)
    }
    async function getPrivacyPolicy() {
        return requestApi.get(
            `/cms/list?slug=privacypolicy`,
            {}
        ).then((res) => {
            setCurrentCmsId(res?.data?.data?.cmsId)
            setckeditordata(res?.data?.data)
            return res?.data?.data
        })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['CMSlist'],
        queryFn: getPrivacyPolicy
    })

    async function addEditPolicy(payload) {
        return requestApi.post(
            `/cms/edit`,
            { ...payload, 
                cmsId: currentCmsId,
                title:'privacy-policy'
            },
            { },
            true
        )
    }
    const editMutation = useMutation(addEditPolicy, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: res?.data?.meta?.message
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: error?.message
            })
        }
    })

    const onEditSubmit = (data) => {
        const payload = {
            description: ckeditordata
        }
        editMutation.mutate(payload)
    }

    return (
        <>
     
        <CMS>
            <div className='head'>
                <h2>Privacy Policy</h2>
            </div>
            <div className='support-body-content'>
                <Form onSubmit={handleSubmit(onEditSubmit)}>
                    <div div className='form-group'>
                              <CKEditor
                        //  data={ckeditordata || ''}
                        data={ckeditordata?.description?.length >= 0 ? ckeditordata?.description : ckeditordata}
                            removePlugins="ckeditor_logo"
                            editor={ClassicEditor}
                            config={{
                                removePlugins: [
                                    'EasyImage',
                                    'ImageUpload',
                                    'MediaEmbed',
                                    'insertTable',
                                ],
                                 allowedContent:true,
                                toolbar: [
                                    'heading',
                                    '|',
                                    'bold',
                                    'italic',
                                    'link',
                                    'bulletedList',
                                    'numberedList',
                                    // "blockQuote",
                                    // 'ckfinder',
                                    '|',
                                    // 'imageTextAlternative',
                                    // 'imageUpload',
                                    // 'imageStyle:full',
                                    // 'imageStyle:side',
                                    // '|',
                                    // 'mediaEmbed',
                                    // 'insertTable',
                                    // "tableColumn",
                                    // "tableRow",
                                    // "mergeTableCells",
                                    '|',
                                    'undo',
                                    'redo'
                                ]
                            }}
                            onReady={(editor) =>
                                // ckeditordata?.description
                                 console.log(editor.getData(), 'hello')
                            }
                            onChange={handleCKEditor}
                        />
                    </div>
                    <button type="submit" className='solid-red-btn'>Save</button>
                </Form>
            </div>
        </CMS>
        </>
    )
}
export default PrivacyPolicy

// import React, { useState } from 'react'
// import ReactQuill,{Quill} from 'react-quill'
// import requestApi from '../../utils/request'
// import { useMutation, useQuery } from '@tanstack/react-query'
// import CMS from '../CMS/CMS'
// import { Form } from 'react-bootstrap'
// import Swal from 'sweetalert2'
// import { useForm } from 'react-hook-form'

// const PrivacyPolicy = () => {

//     const [content, setContent] = useState('')
//     const [currentCMSId,setcurrentCMSId] = useState("")

//     const {register, handleSubmit, formState:{errors}} = useForm()

//     //#region  GetEditor Data
//     async function getPrivacyPolicyData() {
//         return requestApi.get(
//             `/cms/list?slug=privacypolicy`,
//             {},
//         ).then((res) => {
//             setcurrentCMSId(res?.data?.data?.cmsId)
//                 setContent(res?.data?.data?.description)
//                 return res.data.data
//             })
//     }
//     //#endregion

//     const { data, isLoading } = useQuery({
//         queryKey: ['CMSlist'],
//         queryFn: getPrivacyPolicyData
//     })

//     const handleEditorChange = (value) => {
//         setContent(value)
//     }

//     //#region Update Editor
//     async function addEditTermsandConditions(payload) {
//         return requestApi.post(`/cms/edit`,
//     { ...payload, title:"privacy-policy"},
//     {},
//     true
// )
//     }
//     //#endregion
//     //#region  AddEdit CMS by SLUG
//     const editMutation = useMutation(addEditTermsandConditions, {
//         onSuccess: (res) => {
//             Swal.fire({
//                 position: 'center',
//                 icon: 'success',
//                 title: '',
//                 text: res?.data?.meta?.message
//             })
//         },
//         onError: (error) => {
//             Swal.fire({
//                 position: 'center',
//                 icon: 'error',
//                 title: '',
//                 text: error?.message
//             })
//         }
//     })
//     //#endregion

//     const onEditSubmit = (data) => {
//         const payload = {
//             description: content
//         }
//         editMutation.mutate(payload)
//     }

//     return (
//         <CMS>
//               <Form onSubmit={handleSubmit(onEditSubmit)}>
//             <div className="head">
//                 <h2>Privacy Policy</h2>
//                 <button type="submit" className='solid-red-btn'>Save</button>
//             </div>
//             <div className="support-body-content">
              
//                     <ReactQuill
//                         theme="snow"
//                         value={content.description?.length>0 ? content.description : content }
//                         onChange={handleEditorChange}
//                     />  
//             </div>
//             </Form>
//         </CMS>
//     )
// }

// export default PrivacyPolicy
